<template>
  <div>
    <countdown :time="totalTime">
      <template slot-scope="props">
        <div class="d-flex align-items-center justify-content-center text-premier-blue mb-4">
          <div class="d-flex justify-content-center my-4">
            <div class="d-flex flex-column align-items-center">
              <span class="font-65px lh-1">0{{ props.hours }}</span>
              <span class="font-22px">JAM</span>
            </div>
            <span class="font-65px lh-1">:</span>
            <div class="d-flex flex-column align-items-center">
              <span v-if="props.minutes <= 9" class="font-65px lh-1">{{ '0' + props.minutes }}</span>
              <span v-else class="font-65px lh-1">{{ props.minutes }}</span>
              <span class="font-22px">MENIT</span>
            </div>
            <span class="font-65px lh-1">:</span>
            <div class="d-flex flex-column align-items-center">
              <span class="font-65px lh-1">
                <template v-if="props.seconds <= 9">
                  {{ '0' + props.seconds }}
                </template>
                <template v-else>
                  {{ props.seconds }}
                </template></span>
              <span class="font-22px">DETIK</span>
            </div>
          </div>
        </div>
      </template>
    </countdown>
    <div class="text-center text-premier-blue">
      <span>Transfer ke Virtual Account BCA:</span>
      <p v-if="vaData.Instruction" class="font-rubik-medium font-24px">
        {{ vaData.Instruction.VirtualAccountNumber }}
        <input v-if="vaData.Instruction.VirtualAccountNumber" id="virtualAccountNumber" type="hidden" :value="vaData.Instruction.VirtualAccountNumber">
        <svg
          width="20"
          height="24"
          viewBox="0 0 18 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="inline-block ml-2 -mt-1 cursor-pointer"
          @click="handleCopyText()"
        >
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1559 4H2.45372C1.54345 4 0.805664 4.77302 0.805664 5.72455V20.2771C0.805664 21.227 1.54345 22 2.45372 22H12.1559C13.0662 22 13.8057 21.227 13.8057 20.2771V5.72455C13.8022 4.77302 13.061 4 12.1559 4Z" fill="#00C300" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1561 0H6.4535C5.54335 0 4.80566 0.773017 4.80566 1.72455V3.17964H13.1251V3.18638H13.2378C14.1446 3.18638 14.884 3.95939 14.8874 4.90924V5.17702H14.8925V18H16.1561C17.0646 18 17.8057 17.227 17.8057 16.2771V1.72455C17.8057 0.773017 17.0646 0 16.1561 0Z" fill="#00C300" />
        </svg>
      </p>
      <span>Jumlah yang harus dibayarkan:</span>
      <p v-if="amount" class="font-rubik-medium font-24px">
        Rp{{ amount | formatMoney }}
      </p>
    </div>
    <div class="bg-light-gray mx-n3 text-premier-blue px-3 py-3">
      <p class="font-20px text-uppercase font-rubik-medium">
        Panduan Pembayaran
      </p>
      <b-button v-b-toggle="'atm-bca'" variant="white-2" block :class="collapse.atmBca ? 'border-rb-r0 border-lb-r0' : 'border-rb-r025 border-lb-r025'">
        <div class="d-flex justify-content-between align-items-center text-premier-blue">
          <span>ATM BCA</span>
          <font-awesome-icon :icon="collapse.atmBca ? 'chevron-up' : 'chevron-down'" />
        </div>
      </b-button>
      <b-collapse id="atm-bca" v-model="collapse.atmBca">
        <div class="shadow mb-3 bg-white p-3" :class="!collapse.atmBca ? 'border-rb-r0 border-lb-r0' : 'border-rb-r025 border-lb-r025'">
          <ol>
            <li class="mb-2">
              Masukkan kartu ATM dan PIN BCA Anda
            </li>
            <li class="mb-2">
              Masuk ke menu TRANSFER dan klik BCA Virtual Account
            </li>
            <li class="mb-2">
              Masukkan Nomor Virtual Account: <br> <span v-if="vaData.Instruction.VirtualAccountNumber" class="font-22px font-rubik-medium">{{ vaData.Instruction.VirtualAccountNumber }}</span>
            </li>
            <li class="mb-2">
              Jumlah yang harus dibayarkan: <br> <span v-if="amount" class="font-22px font-rubik-medium">Rp{{ amount | formatMoney }}</span>
            </li>
            <li class="mb-2">
              Ikuti instruksi untuk meyelesaikan transaksi
            </li>
          </ol>
        </div>
      </b-collapse>

      <b-button v-b-toggle="'klik-bca'" class="mt-3" variant="white-2" block :class="collapse.klikBca ? 'border-rb-r0 border-lb-r0' : 'border-rb-r025 border-lb-r025'">
        <div class="d-flex justify-content-between align-items-center text-premier-blue">
          <span>KLIK BCA</span>
          <font-awesome-icon :icon="collapse.klikBca ? 'chevron-up' : 'chevron-down'" />
        </div>
      </b-button>
      <b-collapse id="klik-bca" v-model="collapse.klikBca">
        <div class="shadow mb-3 bg-white p-3" :class="!collapse.atmBca ? 'border-rb-r0 border-lb-r0' : 'border-rb-r025 border-lb-r025'">
          <ol>
            <li class="mb-2">
              Login ke KLIK BCA
            </li>
            <li class="mb-2">
              Pilih TRANSFER DANA > TRANSFER KE BCA VIRTUAL ACCOUNT
            </li>
            <li class="mb-2">
              Masukkan Nomor Virtual Account: <br> <span v-if="vaData.Instruction.VirtualAccountNumber" class="font-22px font-rubik-medium">{{ vaData.Instruction.VirtualAccountNumber }}</span>
            </li>
            <li class="mb-2">
              Jumlah yang harus dibayarkan: <br> <span v-if="amount" class="font-22px font-rubik-medium">Rp{{ amount | formatMoney }}</span>
            </li>
            <li class="mb-2">
              Ikuti instruksi untuk meyelesaikan transaksi
            </li>
          </ol>
        </div>
      </b-collapse>

      <b-button v-b-toggle="'m-bca'" class="mt-3" variant="white-2" block :class="collapse.mBca ? 'border-rb-r0 border-lb-r0' : 'border-rb-r025 border-lb-r025'">
        <div class="d-flex justify-content-between align-items-center text-premier-blue">
          <span>m-BCA (BCA MOBILE)</span>
          <font-awesome-icon :icon="collapse.mBca ? 'chevron-up' : 'chevron-down'" />
        </div>
      </b-button>
      <b-collapse id="m-bca" v-model="collapse.mBca">
        <div class="shadow mb-3 bg-white p-3" :class="!collapse.atmBca ? 'border-rb-r0 border-lb-r0' : 'border-rb-r025 border-lb-r025'">
          <ol>
            <li class="mb-2">
              Login ke m-BCA
            </li>
            <li class="mb-2">
              Pilih M-TRANSFER > TRANSFER KE BCA VIRTUAL ACCOUNT
            </li>
            <li class="mb-2">
              Masukkan Nomor Virtual Account: <br> <span v-if="vaData.Instruction.VirtualAccountNumber" class="font-22px font-rubik-medium">{{ vaData.Instruction.VirtualAccountNumber }}</span>
            </li>
            <li class="mb-2">
              Jumlah yang harus dibayarkan: <br> <span v-if="amount" class="font-22px font-rubik-medium">Rp{{ amount | formatMoney }}</span>
            </li>
            <li class="mb-2">
              Masukkan PIN m-BCA Anda
            </li>
            <li class="mb-2">
              Ikuti instruksi untuk meyelesaikan transaksi
            </li>
          </ol>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown'
Vue.component(VueCountdown.name, VueCountdown)

export default {
  name: 'PaymentVa',
  data: () => ({
    collapse: {
      atmBca: false,
      klikBca: false,
      mBca: false
    },
    vaData: {
      Instruction: {
        Childs: [],
        VirtualAccountNumber: ''
      }
    },
    amount: null,
    status: null,
    totalTime: 0,
    endTime: null,
    interval: null
  }),
  mounted () {
    this.interval = setInterval(() => {
      this.fetchingVa()
    }, 3000)
  },
  methods: {
    fetchingVa () {
      const va_id = localStorage.getItem('va_id')
      if (va_id) {
        const payload = {
          id: va_id,
          token: localStorage.getItem('token')
        }
        this.$store.dispatch('doctor/virtualAccountPayment', payload)
          .then((res) => {
            if (res && res.DetailVA) {
              this.vaData = res.DetailVA
            }

            this.amount = res.TotalPaymentAmount
            this.status = res.PaymentStatus
            this.checkPaymentStatus()
            this.checkAvailableResend()
            this.$store.commit('doctor/SET_BOOKING_FINISHED', true)
          })
          .catch((error) => {
            // if (error.Message === 'RESOURCE_NOT_FOUND') {
            //
            // }
            throw new Error(error)
          })
      }
    },
    checkPaymentStatus () {
      if (this.status === 'SUCCESS') {
        localStorage.removeItem('va_id')
        localStorage.setItem('step', 'payment-success')
        return this.$store.commit('doctor/SET_STEP', 'payment-success')
      }
      if (this.status === 'EXPIRED') {
        this.$swal({
          title: 'Pembayaran VA Kadaluarsa',
          text: '',
          icon: 'warning',
          timer: 2000
        }).then(() => {
          localStorage.removeItem('va_id')
          localStorage.setItem('step', 'initial')
          this.$emit('closed')
          return this.$store.commit('doctor/SET_STEP', 'initial')
        })
      }
    },
    checkAvailableResend () {
      if (this.$store.state.doctor.booking.va.DetailVA) {
        this.endTime = this.$store.state.doctor.booking.va.DetailVA.ExpiredAt * 1000
      }

      const dateNow = this.$moment().unix()
      this.totalTime = this.endTime - (dateNow * 1000)
    },
    handleCopyText () {
      if (process.client) {
        const testingCodeToCopy = document.querySelector('#virtualAccountNumber')
        testingCodeToCopy.setAttribute('type', 'text')
        testingCodeToCopy.select()
        try {
          const successful = document.execCommand('copy')
          if (successful) {
            this.$swal({
              text: 'Salin teks berhasil!',
              timer: 2000,
              icon: 'success'
            })
          } else {
            this.$swal({
              text: 'Salin teks gagal!',
              timer: 2000,
              icon: 'error'
            })
          }
        } catch (err) {
          this.$swal({
            text: 'Salin teks gagal!',
            timer: 2000,
            icon: 'error'
          })
        }

        /* unselect the range */
        testingCodeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      }
    }
  }
}
</script>

<style>
.font-65px {
  font-size: 65px !important;
}
.font-24px {
  font-size: 24px !important;
}
.font-22px {
  font-size: 22px !important;
}
.font-20px {
  font-size: 20px;
}
</style>
